<template>
  <div @click="close" :class="[className, { isActive: modelValue, isMedium, modal: !mobileOnly, 'modal--Mobile': mobileOnly }]">
    <div class="modal__Wrapper" :class="{ isMobileOnly: mobileOnly }" ref="modal" @click.stop>
      <div class="modal__CloseButtonWrapper">
        <button class="modal__Close" @click="close" aria-label="Close">
          <client-only>
            <Icon name="close" />
          </client-only>
        </button>
      </div>

      <div class="modal__Content">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
  const emit = defineEmits(['update:modelValue', 'close', 'blocked'])
  const props = defineProps({
    modelValue: {},
    class: {},
    medium: {
      default: false
    },
    focusInput: {
      default: false
    },
    mobileOnly: {
      default: false
    },
    persistent: {
      type: Boolean,
      default: false
    }
  })

  const modal = ref(null)
  const className = props.class
  const isMedium = computed(() => props.medium !== false)
  const { fieldValue } = useFormField(props, emit)

  function close() {
    // persistent modal can't be closed with X or outside click, the parent closes it
    if (props.persistent) {
      emit('blocked')
      return
    }
    fieldValue.value = false
    emit('close')
  }

  watch(fieldValue, () => {
    if (fieldValue.value) {
      if (props.focusInput !== false) {
        setTimeout(() => {
          modal.value.querySelector('input').focus()
        }, 100)
      }
    }
  })
</script>